import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-purchase-widget',
    templateUrl: './purchase-widget.component.html',
    styleUrl: './purchase-widget.component.scss',
    standalone: true
})
export class PurchaseWidgetComponent implements OnInit, AfterViewInit {
  urlSafe: SafeResourceUrl = '';
  state:string = "CA";
  widgetUrl: string = environment.widgetUrl;
  constructor(public em: EventsManager,private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    let url: string = this.widgetUrl+"?state="+this.em.selectedState.abbr+"&organization="+this.em.orgId+"&branding=sgdp"
    if(this.em.purchaseIsADHA){
      url = this.widgetUrl+"?practice="+this.em.adhaPractice+"&branding=sgdp"
    }
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngAfterViewInit(){
    window.scroll(0,0);
  }
}
